export const useClientSideState = <T>(
  key: string,
  init: (() => unknown) | (() => T | Ref<T>) | undefined
) =>
  process.client
    ? useState<T>(key, init as () => T | Ref<T>)
    : ref<T>(init as T)
